export default __webpack_public_path__ + "79fa0ebbce159d7e12626cf57d322d6f.png";